import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import routeToPermission from "./routeToPermission";

const ProtectedRoute = ({ children, areaKey }) => {
  const { currentUser, userPermissions } = useAuth();
  const permissionName = routeToPermission[areaKey];
  const permissionValue = permissionName
    ? userPermissions?.[permissionName]
    : undefined;
  const canView = permissionValue?.view || false;

  // Debugging: log permission resolution logic
  // Remove or comment out after troubleshooting
  if (process.env.NODE_ENV !== "production") {
    console.log("[ProtectedRoute] areaKey:", areaKey);
    console.log("[ProtectedRoute] permissionName:", permissionName);
    console.log("[ProtectedRoute] permissionValue:", permissionValue);
    console.log("[ProtectedRoute] currentUser:", currentUser?.uid || null);
    console.log(
      "[ProtectedRoute] userPermissions keys:",
      userPermissions ? Object.keys(userPermissions) : null,
    );
    console.log("[ProtectedRoute] canView:", canView);
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  if (areaKey && !canView) {
    return <Navigate to="/unauthorized" />;
  }
  return children;
};

export default ProtectedRoute;
